import type { AlertColor } from "@mui/material/Alert";

// Тип опций для Snackbar
export interface SnackbarOptions {
  message: string;
  severity?: AlertColor;
  duration?: number;
}

// Ссылка на функцию showSnackbar из контекста
let showSnackbarRef: ((options: SnackbarOptions) => void) | null = null;

export function setShowSnackbarRef(fn: (options: SnackbarOptions) => void) {
  showSnackbarRef = fn;
}

export function showGlobalSnackbar(options: SnackbarOptions) {
  if (showSnackbarRef) {
    showSnackbarRef(options);
  } else {
    // Можно добавить fallback: например, console.warn
    console.warn("Snackbar not initialized yet", options);
  }
}
